<template>
  <div class="users-table">
    <v-data-table
      :headers="headers"
      :pagination.sync="pagination"
      :items="items"
      hide-actions
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <!-- <td>
            <v-btn icon >
              <v-icon v-if="!props.expanded">expand_more</v-icon>
              <v-icon v-else>expand_less</v-icon>
            </v-btn>
          </td> -->
          <td>
            <v-avatar :size="24">
              <img :src="props.item.photoUrl"></img>
            </v-avatar>
            {{ props.item.name }}
          </td>
          <td>{{ props.item.email }}</td>
          <td>{{ props.item.invitedBy }}</td>
          <td>{{ props.item.roles }}</td>
        </tr>
      </template>
      <!-- <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>
            <div class="url">
              {{ getUrl(props.item.id) }}
            </div>
            <div v-if="props.item.email && props.item.email.email">
              <p><strong>Тема листа: </strong>{{ props.item.email.subject }}</p>
              <p><div><strong>Текст: </strong></div>{{ props.item.email.text }}</p>
            </div>

            <div v-if="props.item.registeredUser && props.item.registeredUser.uid">
              <div><strong>Зареєстрований користувач</strong></div>
              <p><strong>Ім'я: </strong>{{ props.item.registeredUser.name }}</p>
              <p><strong>Пошта: </strong>{{ props.item.registeredUser.email }}</p>
            </div>
          </v-card-text>
        </v-card>
      </template> -->
    </v-data-table>
  </div>
</template>

<script>

const headers = [
  { text: 'Ім\'я', value: 'title' },
  { text: 'Email', value: 'email' },
  { text: 'Ким запрошений', value: 'invitedBy' },
  { text: 'Ролі', value: 'roles' },
];

export default {
  name: 'UsersTable',
  props: {
    users: {
      type: Array,
      required: true,
    },
    invites: {
      type: Array,
    },
  },
  data() {
    return {
      headers,
      pagination: {
        descending: true,
        sortBy: 'created',
      },
    };
  },
  computed: {
    items() {
      return this.users.map((user) => {
        const roles = Object.keys(user.roles).filter(role => user.roles[role]).join(', ');
        const invite = (this.invites || []).find(item => item.id === user.invite);
        return {
          ...user,
          roles,
          invitedBy: invite && invite.author && invite.author.name,
          // invitedBy: invite && invite.title,
        };
      });
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/UsersTable.vue